import { useState, useEffect } from "react";
import Header from "./components/Header"
import Stepper from "./components/Stepper"
import configData from "./config.json";
import api from "./axiosInterceptor"; // Import the Axios instance
import { useCartStore } from "./cartStore";
import Cookies from "js-cookie";
import Swal from 'sweetalert2';

function AddOrder() {
  const [products, setProducts] = useState([]);
  const { cart } = useCartStore();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await api.get("/products/");
        setProducts(response.data);
      } catch (error) {
        console.error("Error no products:", error);
      }
    };

    fetchProducts();
  }, []);

  // Función para abrir la modal con la imagen ampliada
  const openImageModal = (imageUrl, productName) => {
    Swal.fire({
      imageUrl: imageUrl,
      imageAlt: productName,
      title: productName,
      showCloseButton: true, // Muestra la 'X' de cierre arriba a la derecha
      showConfirmButton: false, // Esconde el botón de 'OK' para que sea más limpio
      focusConfirm: false,
      customClass: {
        image: 'img-fluid' // Clase opcional por si usas Bootstrap para asegurar que sea responsiva
      }
    });
  };

  const makeOrder = async () => {
    const userId = Cookies.get("agpunchout-authorization-user"); 
    const sessionId = Cookies.get("agpunchout-authorization-session"); 
    
    const order = {
      user: {
        id: parseInt(userId),
      },
      request: {
        id: parseInt(sessionId),
      },
      order_lines: cart
        .filter((item) => parseInt(item.quantity) > 0)
        .map((item) => ({
          product: { id: item.id },
          quantity: item.quantity,
        })),
    };

    try {
      const response = await api.post("/orders/", order);
      console.log(response)
      if(response.status == 200){
          window.close(); 
      }
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: error.response?.data.error || error.error,
        icon: 'error',
        confirmButtonText: 'OK'
      })
    }
  };

  return (
    <div>
      <Header title="Pedido" subtitle="Hacer un nuevo pedido" icon="layout" />

      <div className="container">
        <div className="card">
          <div className="card-header">Productos</div>
          <div className="card-body">
            <div className="datatable">
              <table
                className="table table-bordered table-hover"
                id="dataTable"
                width="100%"
                cellSpacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Marca</th>
                    <th>Producto</th>
                    <th>PN</th>
                    <th>Precio</th>
                    <th>Canon</th>
                    <th>Cantidad</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th>Marca</th>
                    <th>Producto</th>
                    <th>PN</th>
                    <th>Precio</th>
                    <th>Canon</th>
                    <th>Cantidad</th>
                  </tr>
                </tfoot>
                <tbody>
                  {products.map((product, index) => (
                    <tr key={index}>
                      <td>
                        {/* Se añade el onClick y estilos de puntero */}
                        <img 
                          src={product.img_url} 
                          width={100} 
                          alt={product.name}
                          onClick={() => openImageModal(product.img_url, product.name)}
                          style={{ cursor: "pointer" }} 
                        />
                      </td>
                      <td>{product.brand}</td>
                      <td>{product.name}</td>
                      <td>{product.part_number}</td>
                      <td>{product.price}</td>
                      <td>{product.canon}</td>
                      <td>
                        <Stepper productId={product.id} initialValue={0} min={0} max={20} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <br></br>

      <div className="container">
        <div className="card">
          <div className="card-header">Check Out</div>
          <div className="card-body text-right">
            <button onClick={makeOrder} className="btn btn-green" type="button">Hacer Pedido</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddOrder;